import {
  base_default,
  n
} from "./anacapri-chunk.3P6V43X6.js";
import {
  AnacapriElement
} from "./anacapri-chunk.3HZGRT44.js";
import {
  customElement_default
} from "./anacapri-chunk.YC5RXRZP.js";
import {
  i
} from "./anacapri-chunk.TOMZZDRF.js";
import {
  ke
} from "./anacapri-chunk.37PM4VTN.js";
import {
  __decorateClass
} from "./anacapri-chunk.AHXTNXK6.js";

// src/components/loading/loading.css
var styles = i`@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

svg {
  animation: spin 1s infinite linear;
}
`;
var loading_default = styles;

// src/components/loading/loading.ts
var Loading = class extends AnacapriElement {
  constructor() {
    super(...arguments);
    this.size = 128 /* XLarge */;
  }
  willUpdate() {
    this.style.height = `${this.size}px`;
  }
  render() {
    return ke`
      <svg
        height="${this.size}px"
        width="${this.size}px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <title>AO Loading Indicator</title>
        <path
          fill="var( --ao-color-sky)"
          d="M347,347l-.45-.45A127.61,127.61,0,0,1,256,384V512a255.19,255.19,0,0,0,181-75c100-100,100-262.07,0-362-4.32-4.32-8.76-8.43-13.3-12.38C475.14,127.19,442.62,251.3,347,347Z"
        />
        <path
          fill="var( --ao-color-attention-light)"
          d="M256,384.64V384a127.6,127.6,0,0,1-90.51-37.49L75,437a255.2,255.2,0,0,0,181,75c141.38,0,256-114.62,256-256,0-6.11-.23-12.16-.65-18.16C502,319.87,391.28,384.64,256,384.64Z"
        />
        <path
          fill="var( --ao-color-attention)"
          d="M165,347l.45-.45A127.61,127.61,0,0,1,128,256H0A255.19,255.19,0,0,0,75,437c100,100,262.07,100,362,0,4.32-4.32,8.43-8.76,12.38-13.3C384.81,475.14,260.7,442.62,165,347Z"
        />
        <path
          fill="var( --ao-color-attention-dark)"
          d="M127.36,256H128a127.6,127.6,0,0,1,37.49-90.51L75,75A255.2,255.2,0,0,0,0,256C0,397.38,114.62,512,256,512c6.11,0,12.16-.23,18.16-.65C192.13,502,127.36,391.28,127.36,256Z"
        />
        <path
          fill="var( --ao-color-steel)"
          d="M165,165l.45.45A127.61,127.61,0,0,1,256,128V0A255.19,255.19,0,0,0,75,75C-25,175-25,337.05,75,437c4.32,4.32,8.76,8.43,13.3,12.38C36.86,384.81,69.38,260.7,165,165Z"
        />
        <path
          fill="var( --ao-color-blue)"
          d="M256,0C114.62,0,0,114.62,0,256c0,6.11.23,12.16.65,18.16,9.31-82,120.07-146.8,255.35-146.8Z"
        />
        <circle fill="var( --ao-color-blue)" cx="256.24" cy="64.07" r="64.03" />
      </svg>
    `;
  }
};
Loading.styles = [base_default, loading_default];
__decorateClass([
  n({ type: Number })
], Loading.prototype, "size", 2);
Loading = __decorateClass([
  customElement_default("ana-loading")
], Loading);

export {
  Loading
};
